var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { EGDSDialogContent, EGDSDialog, EGDSDialogFooter } from '@egds/react-core/dialog';
import { EGDSHeading } from '@egds/react-core/text';
var ExternalDialogBox = /** @class */ (function (_super) {
    __extends(ExternalDialogBox, _super);
    function ExternalDialogBox(props) {
        var _this = _super.call(this, props) || this;
        _this.dialogId = 'externalDialog';
        _this.default = {
            preTitle: null,
            title: '',
            message: '',
            buttons: []
        };
        var preTitle = props.preTitle, title = props.title, message = props.message, buttons = props.buttons;
        _this.state = __assign(__assign({}, _this.default), { preTitle: preTitle, title: title, message: message, buttons: buttons });
        return _this;
    }
    /* eslint-disable react/no-unused-class-component-methods */
    ExternalDialogBox.prototype.setDetails = function (detail) {
        var preTitle = detail.preTitle, title = detail.title, message = detail.message, buttons = detail.buttons;
        this.setState(__assign(__assign({}, this.default), { preTitle: preTitle, title: title, message: message, buttons: buttons }));
    };
    ExternalDialogBox.prototype.renderFooter = function () {
        var buttons = this.state.buttons;
        if (buttons) {
            var footerProps = {
                buttonOne: __assign(__assign({}, buttons[0]), { type: 'primary' })
            };
            if (buttons[1]) {
                footerProps.buttonTwo = __assign(__assign({}, buttons[1]), { type: 'primary' });
            }
            if (buttons[2]) {
                footerProps.buttonThree = __assign(__assign({}, buttons[2]), { type: 'primary' });
            }
            return React.createElement(EGDSDialogFooter, __assign({}, footerProps));
        }
    };
    ExternalDialogBox.prototype.render = function () {
        var _a = this.state, preTitle = _a.preTitle, title = _a.title, message = _a.message;
        function innerHtml(text) {
            return { __html: text };
        }
        /* eslint-disable react/no-danger */
        return (React.createElement(EGDSDialog, { key: this.dialogId, dialogShow: true },
            React.createElement(EGDSDialogContent, { key: "content-".concat(this.dialogId) },
                preTitle && (React.createElement("p", { key: "preTitle-".concat(this.dialogId), dangerouslySetInnerHTML: innerHtml(preTitle) })),
                React.createElement(EGDSHeading, { key: "title-".concat(this.dialogId), tag: "h1", size: 5 }, title),
                React.createElement("p", { key: "message-".concat(this.dialogId), dangerouslySetInnerHTML: innerHtml(message) })),
            this.renderFooter()));
        /* eslint-enable react/no-danger */
    };
    return ExternalDialogBox;
}(React.Component));
export { ExternalDialogBox };
//# sourceMappingURL=external-dialog-box.js.map